// extracted by mini-css-extract-plugin
export default {"container":"cashier-balances_container__wT2QW","balance":"cashier-balances_balance__tYqqD"};